import React, { useCallback, useEffect, useState } from 'react';
import { Tag, Button, Card, Col, Divider, Form, Input, InputNumber, Popconfirm, Row, Select, Space, Tooltip, message, Modal, Checkbox, notification, DatePicker } from 'antd';
import { EditOutlined, SaveOutlined, SearchOutlined } from '@ant-design/icons';
import { useStoreActions, useStoreState } from '../../../../store/hooks/easyPeasy';
import moment from 'moment';
import Tablex from "../../../../contents/AntTableResponsive";

import { useTable, usePagination, useFilters, useRowSelect } from "react-table";

const EditableCell = ({
    value: initialValue,
    row: { index },
    column: { id },
    updateMyData // This is a custom function that we supplied to our table instance
}) => {
    // We need to keep and update the state of the cell normally
    // console.log(id)
    const [value, setValue] = React.useState(initialValue);

    const onChange = (e) => {
        setValue(e.target.value);
    };
    const onChangeDate = (e) => {
        setValue(moment(e._d).format("YYYY-MM-DD"));
    };

    // We'll only update the external data when the input is blurred
    const onBlur = () => {
        updateMyData(index, id, value);
    };

    // If the initialValue is changed external, sync it up with our state
    React.useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    if (id === 'religion') {
        return <div className="select-box">
            <select
                id="select-box1"
                value={value}
                onChange={onChange}
                className='tableDropDown'
                style={{ width: 150 }}
                onBlur={onBlur}
            >
                <option value="Islam">Islam</option>
                <option value="Hinduism">Hinduism</option>
                <option value="Christian">Christian</option>
                <option value="Buddist">Buddist</option>
                <option value="Other">Other</option>
            </select>
        </div>
    }
    if (id === 'gender') {
        return <div className="select-box">
            <select
                id="select-box1"
                value={value}
                onChange={onChange}
                className='tableDropDown'
                style={{ width: 120 }}
                onBlur={onBlur}
            >
                <option value="Male">Male</option>
                <option value="Female">Female</option>
            </select>
        </div>
    }

    if (id === 'dob') {
        if (value !== '' ) return <DatePicker onBlur={onBlur} onChange={onChangeDate} allowClear={false} value={(moment(value?.split('-').join('/')))} style={{ width: 150, border: "1px solid #03D665" }} />
        if (value === null ) return <DatePicker onBlur={onBlur} value={null} onChange={onChangeDate} allowClear={false} style={{ width: 150, border: "1px solid #03D665" }} />
        else return <DatePicker onBlur={onBlur} allowClear={false} value={null} onChange={onChangeDate} style={{ width: 150, border: "1px solid #03D665" }} />

    }

    else return <input className="ant-input" style={{ border: "1px solid #03D665" }} value={value} onChange={onChange} onBlur={onBlur} />;
};



// Define a default UI for filtering
function DefaultColumnFilter({
    column: { filterValue, preFilteredRows, setFilter },
}) {
    const count = preFilteredRows.length

    return (
        <input
            className="ant-input"
            style={{ border: "1px solid #F0F0F0" }}
            value={filterValue || ''}
            onChange={e => {
                setFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
            }}
            placeholder={`Search ${count} records...`}
        />
    )
}

interface Props {
    indeterminate?: boolean;
    name: string;
}

const IndeterminateCheckbox = React.forwardRef<HTMLInputElement, Props>(
    ({ indeterminate, ...rest }, ref) => {
        const defaultRef: any = React.useRef()
        const resolvedRef = ref || defaultRef

        React.useEffect(() => {
            if (resolvedRef?.current) {
                resolvedRef.current.indeterminate = indeterminate
            }
        }, [resolvedRef, indeterminate])

        return (
            <>
                <input className='customCheckbox' type="checkbox" ref={resolvedRef} {...rest} />
            </>
        )
    }
)

// Set our editable cell renderer as the default Cell renderer
const defaultColumn = {
    Filter: DefaultColumnFilter,
    Cell: EditableCell,

};

// Be sure to pass our updateMyData and the skipPageReset option
function Table({ columns, data, updateMyData, skipPageReset, onRowSelect }) {
    // For this example, we're using pagination to illustrate how to stop
    // the current page from resetting when our data changes
    // Otherwise, nothing is different here.
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        rows,
        selectedFlatRows,
        state: { pageIndex, pageSize, selectedRowIds }
    } = useTable(
        {
            columns,
            data,
            defaultColumn,
            initialState: { pageSize: 10 },
            autoResetFilters: false,
            // use the skipPageReset option to disable page resetting temporarily
            autoResetPage: !skipPageReset,
            // updateMyData isn't part of the API, but
            // anything we put into these options will
            // automatically be available on the instance.
            // That way we can call this function from our
            // cell renderer!
            updateMyData
        },
        useFilters, // useFilters!
        usePagination,
        useRowSelect,
        hooks => {
            hooks.visibleColumns.push(columns => [
                // Let's make a column for selection
                {
                    id: 'selection',
                    // The header can use the table's getToggleAllRowsSelectedProps method
                    // to render a checkbox
                    Header: ({ getToggleAllRowsSelectedProps }) => (
                        <div>
                            <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
                        </div>
                    ),
                    // The cell can use the individual row's getToggleRowSelectedProps method
                    // to the render a checkbox
                    Cell: ({ row }) => (
                        <div>
                            <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
                        </div>
                    ),
                },
                ...columns,
            ])
        }

    );
    React.useEffect(() => {
        onRowSelect(selectedFlatRows);
    }, [selectedFlatRows]);
    return (
        <>
            <div className='ant-table-content' style={{ width: "100%" }}>
                <div style={{ overflow: "auto" }}>
                    <table {...getTableProps()} className='shebaTable' style={{ width: "100%" }}>
                        <thead className='ant-table-thead'>
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        <th className='ant-table-cell' {...column.getHeaderProps({ style: { minWidth: column.minWidth, width: column.width } })} >{column.render("Header")}
                                            <div>{column.canFilter ? column.render('Filter') : null}</div>
                                        </th>

                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody className='ant-table-tbody' {...getTableBodyProps()}>
                            {page.length > 0 && page.map((row, i) => {
                                prepareRow(row);
                                return (
                                    <tr className={`ant-table-row ant-table-row-level-${i}`} {...row.getRowProps()}>
                                        {row.cells.map((cell) => {
                                            return (
                                                <td className='ant-table-cell' {...cell.getCellProps()}>{cell.render("Cell")}</td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                <br />
                <div className="pagination" style={{ float: 'right' }}>
                    <button onClick={() => gotoPage(0)} disabled={!canPreviousPage} style={{ height: 40 }}>
                        {"<<"}
                    </button>{" "}
                    <button onClick={() => previousPage()} disabled={!canPreviousPage} style={{ height: 40 }}>
                        {"<"}
                    </button>{" "}
                    <button onClick={() => nextPage()} disabled={!canNextPage} style={{ height: 40 }}>
                        {">"}
                    </button>{" "}
                    <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage} style={{ height: 40 }}>
                        {">>"}
                    </button>{" "}
                    <span>
                        Page{" "}
                        <strong>
                            {pageIndex + 1} of {pageOptions.length}
                        </strong>{" "}
                    </span>
                    <span>
                        | Go to page:{" "}
                        <input
                            type="number"
                            defaultValue={pageIndex + 1}
                            onChange={(e) => {
                                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                gotoPage(page);
                            }}
                            className="ant-input"
                            style={{ width: "100px", height: 40, border: "1px solid #03D665" }}
                        />
                    </span>{" "}
                    <select
                        value={pageSize}
                        onChange={(e) => {
                            setPageSize(Number(e.target.value));
                        }}
                        style={{ height: 40, border: "1px solid #03D665" }}
                    >
                        {[10, 20, 30, 40, 50, 100, 200, 500, 1000].map((pageSize) => (
                            <option key={pageSize} value={pageSize}>
                                Show {pageSize}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </>
    );
}



export default function BasicUpdate() {

    const { Option } = Select;
    const [searchStudentForm] = Form.useForm();
    const [studentUpdateForm] = Form.useForm();
    const fetchSessionList = useStoreActions((state) => state.student.fetchSessionList);
    const sessionList = useStoreState((state) => state.student.sessionList);
    const fetchClassConfigList = useStoreActions((state) => state.student.fetchClassConfigList);
    const classConfigList = useStoreState((state) => state.student.classConfigList);
    const fetchStudentListByClassConfigId = useStoreActions((state) => state.student.fetchStudentListByClassConfigId);
    const studentListByClassConfigId = useStoreState((state) => state.student.studentListByClassConfigId);
    const updateStudentBasicInfo = useStoreActions((state) => state.student.updateStudentBasicInfo);
    const [selectedSessionYear, setselectedSessionYear] = useState();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedRowKeys, setselectedRowKeys] = useState<any>([]);
    const [selectedValue, setselectedValue] = useState<any>([]);

    useEffect(() => {
        fetchSessionList();
        fetchClassConfigList();
    }, []);

    const onSelectChange = (selectedRowKeys, value) => {
        setselectedRowKeys(selectedRowKeys);
        setselectedValue(value);
    };


    const [datay, setDatay] = useState<any>();

    const searchStudentList = (value) => {
        let payload = {
            classDeptConfId: value.classDepartment,
            sessionId: value.sessionYearName
        };
        setDatay(payload);
        fetchStudentListByClassConfigId(payload);
    }

    const [selectedRows, setSelectedRows] = React.useState<any>([]);
    const updateStudentInfo = (value) => {
        let checkSelectedRow = selectedRows.length;
        if (checkSelectedRow > 0) {
            let updateValueArray: any = [];
            selectedRows?.map((item: any) => {
                let updateData = {
                    studentId: item.original.studentId,
                    customStudentId: item.original.customStudentId,
                    fatherName: item.original.fatherName,
                    gender: item.original.gender,
                    motherName: item.original.motherName,
                    registrationNo: item.original.registrationNo,
                    religion: item.original.religion,
                    studentMobile: item.original.studentMobile,
                    dob: item.original.dob,
                    studentName: item.original.studentName,
                }
                updateValueArray.push(updateData);
            });
            updateStudentBasicInfo(updateValueArray);
            // searchStudentForm.resetFields();
            setTimeout(() => {
                fetchStudentListByClassConfigId(datay);
            }, 600);
        } else {
            notification.error({ message: 'Select the table row first' });
        }
    }


    const [tableRowStore, setTableRowStore] = useState<any>([]);

    useEffect(() => {
        setTableRowStore(studentListByClassConfigId);
    }, [studentListByClassConfigId]);



    const columnsx = React.useMemo(
        () => [
            {
                Header: "Student Id",
                accessor: "customStudentId",
                maxWidth: 400,
                minWidth: 140,
                width: 200,
            },
            {
                Header: "Student Name",
                accessor: "studentName",
                maxWidth: 400,
                minWidth: 250,
                width: 250,
            },
            {
                Header: "Student Mobile",
                accessor: "studentMobile",
                maxWidth: 400,
                minWidth: 140,
                width: 200,
            },
            {
                Header: "Date of Birth",
                accessor: "dob",
                disableFilters: true,
                maxWidth: 400,
                minWidth: 150,
                width: 200,
            },
            {
                Header: "Registration No",
                accessor: "registrationNo",
                disableFilters: true,
                maxWidth: 400,
                minWidth: 250,
                width: 250,
            },
            {
                Header: "Father Name",
                accessor: "fatherName",
                disableFilters: true,
                maxWidth: 400,
                minWidth: 250,
                width: 250,
            },
            {
                Header: "Mother Name",
                accessor: "motherName",
                disableFilters: true,
                maxWidth: 400,
                minWidth: 250,
                width: 250,
            },
            {
                Header: "Religion",
                accessor: "religion",
                disableFilters: true,
                maxWidth: 400,
                minWidth: 140,
                width: 200,
            },
            {
                Header: "Gender",
                accessor: "gender",
                disableFilters: true,
                maxWidth: 400,
                minWidth: 140,
                width: 200,
            },

        ],
        [studentListByClassConfigId]
    );


    const [skipPageReset, setSkipPageReset] = React.useState(false);

    // We need to keep the table from resetting the pageIndex when we
    // Update data. So we can keep track of that flag with a ref.

    // When our cell renderer calls updateMyData, we'll use
    // the rowIndex, columnId and new value to update the
    // original data
    const updateMyData = (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        setSkipPageReset(true);
        setTableRowStore((old) =>
            old.map((row, index) => {
                if (index === rowIndex) {
                    return {
                        ...old[rowIndex],
                        [columnId]: value
                    };
                }
                return row;
            })
        );
    };


    return (
        <>
            <Card title="Student Basic Update">
                <Row>
                    <Col xs={{ span: 24, offset: 0 }} sm={{ span: 24, offset: 0 }} md={{ span: 24 }} lg={{ span: 12, offset: 6 }} xl={{ span: 12, offset: 6 }}>
                        <Form
                            layout="vertical"
                            id="sessionYearInfo"
                            onFinish={searchStudentList}
                            form={searchStudentForm}
                        >
                            <Row>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 10 }} lg={{ span: 10 }} xl={{ span: 10 }}>
                                    <Form.Item
                                        name="sessionYearName"
                                        label="Session Year"
                                        className="title-Text"
                                        rules={[
                                            { required: true, message: "Please write session year" },
                                        ]}
                                    >
                                        <Select
                                            placeholder="Select session"
                                        >
                                            {sessionList ? (
                                                sessionList.map((type, idx) => (
                                                    <Option key={type.id} value={type.id}>
                                                        {type.name}
                                                    </Option>
                                                ))
                                            ) : (
                                                <Option value="fetching">Fetching Session</Option>
                                            )}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 10 }} lg={{ span: 10 }} xl={{ span: 10 }}>
                                    <Form.Item
                                        name="classDepartment"
                                        label="Class Department"
                                        className="title-Text"
                                        rules={[
                                            { required: true, message: "Select class-department" },
                                        ]}
                                    >
                                        <Select
                                            placeholder="Select class-department"
                                        >
                                            {classConfigList ? (
                                                classConfigList.map((type, idx) => (
                                                    <Option key={type.configId} value={type.configId}>
                                                        {type.configName}
                                                    </Option>
                                                ))
                                            ) : (
                                                <Option value="fetching">Fetching Class</Option>
                                            )}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                                    <Space size="small" >
                                        <Button type="primary" htmlType="submit" icon={<SearchOutlined />} >
                                            Search
                                        </Button>
                                    </Space>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
                <div>
                    {tableRowStore?.length > 0 &&
                        <>
                            <Row className="m-t-mo-30">
                                <Col span="24" style={{ overflow: "auto" }}>
                                    {/* <Tablex
                                antTableProps={{
                                    showHeader: true,
                                    rowSelection: rowSelection,
                                    columns,
                                    dataSource: tableRowStore,
                                    bordered: true,
                                    rowKey: "key",
                                    pagination: { defaultPageSize: 5, showSizeChanger: true, pageSizeOptions: ['5', '10', '15', '20', '25'] },
                                }}
                                mobileBreakPoint={768}

                            /> */}
                                    <Table
                                        columns={columnsx}
                                        data={tableRowStore}
                                        updateMyData={updateMyData}
                                        skipPageReset={skipPageReset}
                                        onRowSelect={rows => setSelectedRows(rows)}
                                    />
                                </Col>
                            </Row>
                            <Row >
                                <Col span="24">
                                    <Button type="primary" icon={<EditOutlined />} style={{ float: 'right' }} onClick={(e) => updateStudentInfo(e)}>
                                        Update
                                    </Button>
                                </Col>
                            </Row>
                        </>
                    }
                </div>
            </Card>
        </>
    )
}